import { Component, Input } from "@angular/core";

@Component({
  selector: "app-slider-arrow-icon",
  templateUrl: "./slider-arrow-icon.component.html",
})
export class SliderArrowIconComponent {
  @Input() direction: "left" | "right";
}
